const Products = [
  {
    path: '/ecommerce/inventory/products',
    name: 'all-products',
    component: () => import(/* webpackChunkName: "all-view" */ './ProductsView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'All Products',
          path: '/ecommerce/inventory/products',
        },
      ],
    },
    children: [
      {
        path: '/',
        name: 'all-products',
        component: () => import(/* webpackChunkName: "all-product" */ './components/Products.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'All Products',
              path: '#',
            },
          ],
        },
      },
      {
        path: 'new',
        name: 'new-products',
        component: () => import(/* webpackChunkName: "create-product" */ './components/CreateProduct.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'New Products',
              path: '#',
            },
          ],
        },
      },
      {
        path: ':id/edit',
        name: 'edit-products',
        component: () => import(/* webpackChunkName: "edit-product" */ './components/EditProduct.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Edit Product',
              path: '#',
            },
          ],
        },
      },
      {
        path: 'csv-upload',
        name: 'csv-upload',
        component: () => import(/* webpackChunkName: "csv-upload" */ './components/CSVUpload.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'CSV File Upload',
              path: '#',
            },
          ],
        },
      },
      {
        path: ':slug/image-upload',
        name: 'image-upload',
        component: () => import(/* webpackChunkName: "image-upload" */ './components/ImageUpload.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Image Upload',
              path: '#',
            },
          ],
        },
      },
    ],
  },
];

export default Products;
